export default __webpack_public_path__ + "static/media/Nike.2bc430b7.svg";